var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPnto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_66",
    "data-name": "Elipse 66",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#263a5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnto);
export default __webpack_public_path__ + "static/media/pnto.e5d803bed9566a5283fb50f9093f4df7.svg";
export { ForwardRef as ReactComponent };